import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { paymentApi } from '@/api/payment';
import type { Subscription } from '@/pages/create-report/billing/types';

type UseSubscriptionStatusResult = {
    subscription: Subscription | undefined;
    hasSubscription: boolean;
    isLoading: boolean;
    isError: boolean;
    refetch: UseQueryResult<Subscription, Error>['refetch'];
};

export function useSubscriptionStatus(
    options: { enabled?: boolean } = {},
): UseSubscriptionStatusResult {
    const query = useQuery<Subscription, Error>({
        queryKey: ['subscription'],
        queryFn: paymentApi.getSubscription,
        enabled: options.enabled ?? true,
        retry: false,
    });

    return {
        subscription: query.data,
        hasSubscription: !!query.data?.plan,
        isLoading: query.isLoading,
        isError: query.isError,
        refetch: query.refetch,
    };
}
